import React, { Component } from 'react';
import Input from './Input';
import Radio from './Radio';
import TextArea from './TextArea';
import ReCAPTCHA from 'react-google-recaptcha';


class Form extends Component {
    state = {
        data: {},
        errors: {},
        displayMessage: false,
    }

    //CHANGE TO APPROPRIATE ENDPOINT WHEN DEPLOYED
    //subject to change when uploaded on server
    emailEndPoint = "https://nalsoft.co.jp/mailer/mail.php";
    captchaKey = "6Lfk3sgcAAAAABxKiNCC4CDGbMO_ZPFOEqspiI3v";
    // This method validates single property/input
    validateProperty = ({ name, value }) => {
        const { error } = this.schema.validate({ [name]: value })
        if (error) {
            return error.details[0].message;
        }
        return null;
    }
    //This method validate the whole form
    validateForm = () => {
        const errors = { ...this.state.errors };
        const { error } = this.schema.validate(this.state.data, { abortEarly: false });
        if (error) {
            error.details.map(detail => {
                errors[detail.context.key] = detail.message;
                return null;
            });
            return errors;
        }
        return;

    }


    onChangeHandler = (e) => {
        const data = { ...this.state.data };
        const errors = { ...this.state.errors };
        this.validateProperty(e.currentTarget);
        const errorMessage = this.validateProperty(e.currentTarget);

        if (errorMessage) {
            errors[e.currentTarget.name] = errorMessage;
        }
        else {
            delete errors[e.currentTarget.name];
        }
        data[e.currentTarget.name] = e.currentTarget.value;
        this.setState({ errors: errors, data });
    }

    onChangeSelect = (e) => {
        const data = { ...this.state.data };
        data[e.currentTarget.name] = e.currentTarget.value;
        this.setState({ data });
    }

    onSubmitHandler = (e) => {
        e.preventDefault();
        const errors = this.validateForm();
        if (errors) {
            this.setState({ displayMessage: true, errors });
            return false;
        }

        //this doSubmit is a function of the child class be sure to implement it
        this.setState({ displayMessage: false });
        this.doSubmit();
        return true;
    }

    //rendering submit button
    renderSubmitButton(classes, buttonName = "submit") {
        return (
            <button className={classes} onClick={this.onSubmitHandler} >
                {buttonName}
            </button>
        );
    }

    //Input TYPE: text, email, password
    renderInputText(name, label, helperText, isRequired = true, type = "text") {
        const { errors, data } = this.state;
        return (
            <Input name={name}
                label={label}
                type={type}
                value={data[name]}
                errorText={errors[name]}
                helperText={helperText}
                required={isRequired}
                onChange={this.onChangeHandler} />
        )
    }

    //Input TYPE: textarea
    renderInputTextArea(name, label, helperText, height, isRequired = true) {
        const { errors, data } = this.state;
        return (
            <TextArea
                height={height}
                name={name}
                label={label}
                value={data[name]}
                errorText={errors[name]}
                helperText={helperText}
                required={isRequired}
                onChange={this.onChangeHandler}
            />
        )
    }
    //input TYPE: radio
    renderInputRadio(name, label, options, defaultValue, isRequired = true) {
        return (
            <Radio
                name={name}
                label={label}
                options={options}
                defaultValue={defaultValue}
                required={isRequired}
                onChange={this.onChangeSelect}
            />
        )
    }

    renderErrorForm() {
        const bool = this.state.displayMessage;
        return (
            <div className={bool ? "alert alert-danger mt-3 " : "d-none"}>
                <span className="text-danger">入力にエラーがあります。</span>
            </div>
        )
    }

    onCaptchaChange = (value) => {
        let data = { ...this.state.data };
        let errors = { ...this.state.errors };
        if (value == null) {
            data['captchaToken'] = "";
            this.setState({ userVerified: false, data });
            return;
        }
        data['captchaToken'] = value;
        delete errors['captchaToken']
        this.setState({ userVerified: true, data, errors });
    }


    renderCaptcha(reference, classes) {
        return (
            <div className={classes}>
                <ReCAPTCHA
                    ref={reference}
                    sitekey={this.captchaKey}
                    onChange={this.onCaptchaChange}
                    hl="ja"
                />
                <span className="text-danger">{this.state.errors['captchaToken'] ? this.state.errors['captchaToken'] : ""}</span>
            </div>
        )
    }
}

export default Form;